import { FormatDateString } from "vanilla-calendar-pro/types";

type FormatDateOptions = {
    yearLastDigits?: boolean;
};

export const DATE_FORMAT = "dd/mm/yyyy";
export const NUMBER_OF_DAYS_IN_WEEK = 7;

export enum Weekday {
    SUNDAY = 0,
    MONDAY = 1,
    TUESDAY = 2,
    WEDNESDAY = 3,
    THURSDAY = 4,
    FRIDAY = 5,
    SATURDAY = 6
}

export function isYearMonthDay(date: string) {
    return /^\d{4}-\d{2}-\d{2}$/.test(date);
}

export function stripTime(date: Date | number) {
    const dateObj = new Date(date);
    dateObj.setHours(0, 0, 0, 0);

    return dateObj;
}

export function getTodayDate() {
    return stripTime(Date.now());
}

export function getDateFromString(date: string) {
    const isYearMonthDayFormat = isYearMonthDay(date);
    const dateParts = date.split(isYearMonthDayFormat ? "-" : "/");

    const day = parseInt(isYearMonthDayFormat ? dateParts[2] : dateParts[0], 10);
    const month = parseInt(dateParts[1], 10) - 1;
    const year = parseInt(isYearMonthDayFormat ? dateParts[0] : dateParts[2], 10);

    const dateObj = new Date(year, month, day);
    return stripTime(dateObj);
}

export function getWeekday(date: string | Date) {
    const parsedDate = typeof date === "string" ? getDateFromString(date) : stripTime(date);
    const weekday = parsedDate.getDay() as Weekday;

    return weekday;
}

export function parseDate(date: string | number | Date | FormatDateString) {
    if (date instanceof Date || typeof date === "number") {
        return stripTime(date);
    }

    if (!date) {
        return undefined;
    }

    return getDateFromString(date);
}

export function formatDate(date: string | number | Date | FormatDateString, options?: FormatDateOptions) {
    if (!date) return "";
    const parsedDate = parseDate(date);

    const day = parsedDate.getDate();
    const dayString = day.toString().padStart(2, "0");

    const month = parsedDate.getMonth() + 1;
    const monthString = month.toString().padStart(2, "0");

    let year = parsedDate.getFullYear();
    let yearString = year.toString();

    if (options?.yearLastDigits) {
        year = year % 100;
        yearString = year.toString().padStart(2, "0");
    }

    return `${dayString}/${monthString}/${yearString}`;
}

export function formatDateToYearMonthDay(date: string | number | Date | FormatDateString) {
    if (!date) return "" as FormatDateString;
    const parsedDate = parseDate(date);

    const day = parsedDate.getDate();
    const month = parsedDate.getMonth() + 1;
    const year = parsedDate.getFullYear();

    return `${year}-${month.toString().padStart(2, "0")}-${day.toString().padStart(2, "0")}` as FormatDateString;
}
